import React, { useState, useEffect } from 'react';
import {
  Container,
  Select,
  ProgressBar,
  FieldContainer,
  Button,
  FieldLabel,
  Fields,
  ButtonContainer,
  Option,
  Input,
  AddressFieldContainer,
  AddressInput,
  AddressFieldLabel,
  StatusLabel 
} from './styled';
import {

  Spinner,
  SpinnerSize,

} from '../../components';
import * as apiClient from "../../common/apiClient";
import * as App_Constant  from "../../common/constants";
import ReportViewer from '../ui/reportViewer/reportviewer';
import { useAppContext } from '../../AppContext';
import ReactSwitch from 'react-switch';
import ReportLogsViewer from '../ui/reportlogs/reportlogviewer';
export const DownloadScan = () => {
  // State for dropdown values
  const { state, dispatch } = useAppContext();
  const [customerFirstName, setCustomerFirstName] = useState<any>('');
  const [customerLastName, setCustomerLastName] = useState<any>('');
  const [customerAddress, setCustomerAddress] = useState<any>('');
  const [regNo, setRegNo] = useState<any>('');
  const [vinNo, setVinNo] = useState<any>('');
  const [requestId, setRequestId] = useState<any>(null);
  const [carMake, setCarMake] = useState<any>('');
  const [carModel, setCarModel] = useState<any>('');
  const [device, setDevice] = useState<any>('');
  const [carMakes, setCarMakes] = useState<any>([]);
  const [carModels, setcarModels] = useState<any>([]);
  const [devices, setDevices] = useState<any>([]);
  const [servers, setServers] = useState<any>([]);
  const [server, setServer] = useState<any>('');
  const [status, setStatus] = useState<any>('');
  const [statusCode, setStatusCode] = useState<any>('');
  const [timerId, setTimerId] = useState<any>(null);
  const [isOpenReport, setIsOpenReport] = useState<any>(false);
  const [isOpenLogReport, setIsOpenLogReport] = useState<any>(false);
  
  const [reportFiles, setReportFiles] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [isCheckOpenRequest, setCheckOpenRequest] = useState<any>(true);
  const [isManualServer, setManualServer] = useState<any>(true);
  // State for scan progress
  const [scanProgress, setScanProgress] = useState(0);

  const showSuccessMessage = (message: any) => {
    apiClient.showSuccessMessage(message);
  };
  const showErrorMessage = (message: any) => {
    apiClient.showErrorMessage(message);
  };
  const handleStartScan = () => {

    if (!customerFirstName) {
      showErrorMessage("Please enter Customer Name");
    }
    // else if (!customerLastName) {
    //   showErrorMessage("Please enter Customer Last Name");
    // }
    // else if (!regNo) {
    //   showErrorMessage("Please enter Reg No");
    // }
    else if (!carMake) {
      showErrorMessage("Please Select Car Make");
    }
    else if (!carModel) {
      showErrorMessage("Please Select Car Model");
    }
    else if (!device) {
      showErrorMessage("Please Select Device");
    }
    else if (isManualServer && (server==null || server==undefined || server=='')) {
      showErrorMessage("Please Select Server");
    }
    else {
      let payload = {
        customer_first_name: customerFirstName,
        customer_last_name: "",
        customer_address: "",
        reg_no: regNo,
        vin_no: vinNo,
        car_model_id: carModel,
        device_id: device,
        user_id: localStorage.getItem("user_id"),
        server_id: server,
        business_partner_id:localStorage.getItem("business_partner_id"),
        manual_assign_server:isManualServer

      }
      
      setIsLoading(true);
      setRequestId(null);
      stopTimer();
      apiClient.post('/requests/create', payload, null).then((response: any) => {
        setIsLoading(false);
        if (response.result) {
          showSuccessMessage(response.message);
          setRequestId(response.request_id);
          startTimer();
        }
        else {
          showErrorMessage(response.message);
          setRequestId(null);
        }
      }).catch((err) => {
        setIsLoading(false);
      })
    }
  };
  
  const handleClose = () => {
    setIsOpenReport(false);
    setIsOpenLogReport(false);
  }
  const handleDownloadReport = () => {
    debugger
    apiClient.get(`request-reports?filter[offset]=0&filter[limit]=100&filter[order]=id%20ASC&filter[where][requestId]=${requestId}`, null).then((response: any) => {
      if(response)
      {
        setIsOpenReport(true);
        setReportFiles(response);
        // response.forEach((element:any) => {          
        //   //downloadReport(element.reportUrl);
        // });
      }
      
    }).catch((err) => {
    })
  };


  const downloadReport = async (reportUrl:any) => {
    
    const link = document.createElement('a');
    link.href = reportUrl;
    link.target = '_blank';
    link.download = `report_${Date.now()}.pdf`; 
    document.body.appendChild(link);
    link.click();
    await new Promise(resolve => setTimeout(resolve, 1000)); // Adjust delay as needed
    document.body.removeChild(link);
  };
  const startTimer = () => {
    const id = setInterval(() => {
      setRequestId((prevRequestId: any) => {
        console.log(prevRequestId, "******requestId*******");
        loadStatus(prevRequestId);
        return prevRequestId;
      });
    }, 5000);

    setTimerId(id);
  };
  const stopTimer = () => {

    if (!requestId) {
      clearInterval(timerId);
    }
  }
  useEffect(() => {
    dispatch({ type: 'UPDATE_TOP_HEADER_TITLE', payload: 'Scan' });
    loadCarMake();
    loadDevices();
    loadServers();
    loadOpenRequest();
  }, []);
  useEffect(() => {
    setRequestId(requestId)
  });
  const loadStatus = (request_id: any) => {

    if (request_id) {
      apiClient.get(`requests/requeststatus/${request_id}`, null).then((response: any) => {
        console.log(response, "******response*******")
        if (response) {
          setStatus(response[0].step_name ? response[0].step_name : response[0].status)
          setStatusCode(response[0].step_code ? response[0].step_code : response[0].status)
          if (response[0].step_value) {
            setScanProgress(response[0].step_value)
         
          }
          else {
            setScanProgress(1)
          }

        }
      }).catch((err) => {
      })
    }


  };
  const loadCarMake = () => {
    apiClient.get('car-makes?filter[offset]=0&filter[limit]=10&filter[order]=id%20ASC', null).then((response: any) => {
      setCarMakes(response);
    }).catch((err) => {
    })
  };
  const loadOpenRequest = () => {
    stopTimer();
    setCheckOpenRequest(true);
    apiClient.get(`requests/openrequest/${localStorage.getItem("user_id")}`, null).then((response: any) => {
      if (response) {
        setRequestId(response[0].request_id)
        setCustomerFirstName(response[0].first_name)
        setCustomerLastName(response[0].last_name)
        setRegNo(response[0].reg_no)
        setVinNo(response[0].vin_no)
        setCustomerAddress(response[0].address)
        setCarMake(response[0].car_make_id)
        setCarModel(response[0].car_model_id)
        setServer(response[0].server_id)
        setDevice(response[0].device_id)
        setStatus(response[0].status)
        loadCarModels(response[0].car_make_id)
        startTimer();

      }
      setCheckOpenRequest(false);
    }).catch((err) => {
      setCheckOpenRequest(false);
    })
  };
  const loadCarModels = (id: any) => {
    setcarModels([]);
    apiClient.get(`car-models?filter[offset]=0&filter[limit]=2500&filter[order]=name%20ASC&filter[where][carMakeId]=${id}`, null).then((response: any) => {
      setcarModels(response);
    }).catch((err) => {
    })
  };
  const loadDevices = () => {
    setDevices([]);

    apiClient.get(`devices?filter[offset]=0&filter[limit]=10&filter[order]=id%20ASC&filter[where][businessPartnerId]=${localStorage.getItem("business_partner_id")}`, null).then((response: any) => {
      setDevices(response);
    }).catch((err) => {
    })
  };

  const loadServers = () => {
    setServers([]); 
    apiClient.get(`servers?filter[offset]=0&filter[limit]=10&filter[order]=name%20ASC&filter[where][enableRouting]=false`, null).then((response: any) => {
      setServers(response);
    }).catch((err) => {
    })
  };

  return (
    
    <Container>
      {isCheckOpenRequest && <Spinner size={SpinnerSize.SMALL} />}
      {!isCheckOpenRequest &&<>
        <Fields>
          <FieldContainer>
            <FieldLabel> Customer </FieldLabel>
            <Input placeholder='Enter Customer Name' value={customerFirstName} onChange={(e) => setCustomerFirstName(e.target.value)} disabled={requestId != null} />
          </FieldContainer>
          {/* <FieldContainer>
            <FieldLabel> Last Name</FieldLabel>
            <Input placeholder='Enter Customer Last Name' value={customerLastName} onChange={(e) => setCustomerLastName(e.target.value)} disabled={requestId != null} />
          </FieldContainer> */}

          {/* <FieldContainer>
            <FieldLabel> Reg No</FieldLabel>
            <Input placeholder='Enter Car Reg No' value={regNo} onChange={(e) => setRegNo(e.target.value)} disabled={requestId != null} />
          </FieldContainer> */}
          {/* <AddressFieldContainer>
            <AddressFieldLabel>Address</AddressFieldLabel>
            <AddressInput placeholder='Enter Customer Complete Address' value={customerAddress} onChange={(e) => setCustomerAddress(e.target.value)} disabled={requestId != null} />
          </AddressFieldContainer> */}
          <FieldContainer>
            <FieldLabel> Car Make</FieldLabel>
            <Select value={carMake} onChange={(e) => {
              setCarMake(e.target.value);
              setCarModel('');
              loadCarModels(e.target.value);
            }} disabled={requestId != null} >
              <Option value="">Select Car Make</Option>
              {carMakes.map((make: any) => (
                <Option key={make.id} value={make.id}>
                  {make.name}
                </Option>
              ))}
            </Select>
          </FieldContainer>

          <FieldContainer>
            <FieldLabel> Car Model</FieldLabel>
            <Select value={carModel} onChange={(e) => setCarModel(e.target.value)} disabled={requestId != null}>
              <Option value="">Select Car Model</Option>
              {carModels.map((model: any) => (
                <Option key={model.id} value={model.id}>
                  {model.name}
                </Option>
              ))}
            </Select>
          </FieldContainer> 
          <FieldContainer>
            <FieldLabel> Vin No</FieldLabel>
            <Input placeholder='Enter Car Vin No' value={vinNo} onChange={(e) => setVinNo(e.target.value)} disabled={requestId != null} />
          </FieldContainer>
          <FieldContainer>
            <FieldLabel> Device</FieldLabel>
            <Select value={device} onChange={(e) => setDevice(e.target.value)} disabled={requestId != null}>
              <Option value="">Select Device</Option>
              {devices.map((d: any) => (
                <Option key={d.id} value={d.id}>
                  {d.name}
                </Option>
              ))}
            </Select>
          </FieldContainer>
          <FieldContainer>
          
            <FieldLabel>Manual Allocation</FieldLabel>
            <FieldLabel><ReactSwitch checked={isManualServer} onChange={(val) =>{setManualServer(val)} } aria-label='Include Invoice' onColor="#1e90ff" offColor="#333" /></FieldLabel>
            
          </FieldContainer>
          
          {isManualServer && <FieldContainer>
          
            <FieldLabel>Server</FieldLabel>
            <Select value={server} onChange={(e) => setServer(e.target.value)} disabled={requestId != null} >
              <Option value={""}>Select Server</Option>
              
              {servers.map((d: any) => (
                <Option key={d.id} value={d.id}>
                  {d.name}
                </Option>
              ))}
            </Select>
          </FieldContainer>
}
         {status!='' && <FieldContainer>
         <StatusLabel style={statusCode==App_Constant.STATUS_COMPLETE?{color:"green"}:{}} >Status:  {status}</StatusLabel> 
          </FieldContainer>
}
        </Fields>
              

        {/* Start Scan Button */}
        {requestId == null && <ButtonContainer>
          <Button
            onClick={handleStartScan}
          >Start Scan</Button>
        </ButtonContainer>
        }
        {requestId != null && <ButtonContainer>         
          <Button onClick={()=>setIsOpenLogReport(true)} >View Logs</Button> 
        </ButtonContainer>
        
        }
          
          {requestId != null && statusCode==App_Constant.STATUS_COMPLETE && <ButtonContainer>         
          <Button
            onClick={handleDownloadReport}
          >Download Report</Button>
          <Button 
            onClick={()=>{
              setRequestId(null)
              setStatus('')
              setStatusCode('') 
              setCustomerFirstName('')
              setCustomerLastName('')
              setRegNo('')
              setVinNo('')
              setCustomerAddress('')
              setCarMake('')
              setCarModel('')
              setServer('')
              setDevice('')
              setScanProgress(0)
            }
            }
          >Start New Scan</Button>
        </ButtonContainer>
        
        }
          
        {scanProgress > 0 && statusCode!=App_Constant.STATUS_COMPLETE && 
        <ProgressBar value={scanProgress} max="100" />}
      </>}
      {isOpenReport && <ReportViewer requestId={requestId} close={handleClose} files={reportFiles}/>}
      {isOpenLogReport  && requestId!=null && <ReportLogsViewer canStop={true} request_id={requestId} close={handleClose} />}
      
    </Container>
  );
};

export default DownloadScan;
